import { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { RateLimit } from 'record-it-utils/utils/RateLimit/RateLimit';
import { StoreUtils } from '../utils/StoreUtils';
const storesToSave = new Map<string, MiddlewareAPI>();
export function createSaveStoreMiddleware(name: string): Middleware {
  return store => next => action => {
    const result = next(action);
    storesToSave.set(name, store);
    rateLimitedSave();
    return result;
  };
}
const rateLimitedSave = RateLimit.rateLimitFunction(async () => {
  const storesToSaveEntries = Array.from(storesToSave.entries());
  storesToSave.clear();
  for (const [name, store] of storesToSaveEntries) {
    await StoreUtils.saveState(name, store.getState());
  }
}, 250);